import { css } from "@obby/components";

export const styles = {
  gallery: css({
    width: "100%"
  }),
  face: css({
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "auto",
    cursor: "pointer"
  }),
  previewWrap: css({
    display: "flex",
    width: "100%"
  }),
  previewImageWrap: css({
    "@md": {
      width: "50%",
      "&:first-child": {
        paddingRight: "12px"
      },
      "&:last-child": {
        paddingLeft: "12px"
      }
    }
  }),
  previewImage: css({
    width: "100%"
  }),
  viewPromptWrap: css({
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100px",
    width: "100px",
    backgroundColor: "$cruise",
    borderRadius: "100%"
  }),
  viewPromptIcon: css({
    height: "65px",
    paddingLeft: "15px"
  })
};
